import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { registersApi, templateApi } from '../services/api';
import { RegisterManagementPage } from './RegisterManagementPage';
import type { Template } from '../types/models';

export const RegistersPage: React.FC = () => {
  // Fetch templates dynamically from the API
  const { data: templatesData } = useQuery({
    queryKey: ['templates', 'risk'],
    queryFn: () => templateApi.list('risk'),
  });

  // Convert templates to dropdown options (only show active templates)
  const templates = templatesData
    ?.filter((t: Template) => t.isActive)
    .map((t: Template) => ({
      value: t.templateName,
      label: t.displayName,
    })) || [];

  // Determine default template (first active template, or fallback)
  const defaultTemplate = templates.length > 0 ? templates[0].value : 'standard';

  return (
    <RegisterManagementPage
      title="Registers"
      iconClass="ri-folder-line"
      queryKey="registers"
      api={registersApi}
      includeDepartments
      templates={templates}
      defaultTemplate={defaultTemplate}
      listPath="/risks"
      configPath="/risk-config"
      applyTemplateKind="risk"
      countField="riskCount"
      countLabel="Risks"
      allowForceDelete
    />
  );
};
